import { useMotion, MODES } from "./MotionProvider";

const LABEL = { full: "Full", reduced: "Reduced", off: "Off" };
const HINT = {
  full: "Every animation on",
  reduced: "Keeps price flashes, toasts, skeletons and loaders; hides decorative motion",
  off: "No motion at all; everything shows its final state",
};

export function MotionSetting() {
  const { mode, setMode } = useMotion();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-[12.5px]" data-testid="motion-setting">
      <span>Animations<span className="block text-[11px] text-muted-foreground">{HINT[mode]}</span></span>
      <div className="flex rounded-full border border-border p-0.5" role="radiogroup" aria-label="Animations">
        {MODES.map((m) => (
          <button key={m} role="radio" aria-checked={mode === m} data-testid={`motion-mode-${m}`} onClick={() => setMode(m)}
            className={`h-7 px-3.5 rounded-full text-[11.5px] font-medium transition-colors duration-200 ${mode === m ? "bg-gold text-[#0b0b0d]" : "text-muted-foreground hover:text-foreground"}`}>
            {LABEL[m]}
          </button>))}
      </div>
    </div>
  );
}
